module.exports = __webpack_public_path__ + "img/image 31 (1).8e3385ee.png";